import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { statsApi } from '@/services/stats';
import { formatPrice } from '@/utils/format';

const todayStr = () => {
  const d = new Date();
  // fecha local en formato YYYY-MM-DD
  const off = d.getTimezoneOffset();
  return new Date(d.getTime() - off * 60000).toISOString().slice(0, 10);
};

// Resumen del día: ingresos agrupados por categoría de producto/servicio.
// Reusa /stats/products/by-category con start_date = end_date = el día elegido.
export default function DailyCategorySummary() {
  const [date, setDate] = useState(todayStr());

  const { data = [], isLoading } = useQuery({
    queryKey: ['sales-by-category-day', date],
    queryFn: () => statsApi.getSalesByCategory({ start_date: date, end_date: date }),
  });

  const total = data.reduce((s, c) => s + (c.total_revenue || 0), 0);

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-3 flex-wrap">
        <label className="text-sm font-medium text-gray-700">Día:</label>
        <input
          type="date"
          value={date}
          onChange={(e) => setDate(e.target.value)}
          className="px-3 py-2 border border-gray-300 rounded-lg text-sm"
        />
        <button
          type="button"
          onClick={() => setDate(todayStr())}
          className="text-sm text-primary-600 hover:text-primary-800"
        >
          Hoy
        </button>
      </div>

      {isLoading ? (
        <div className="text-center py-8 text-gray-500">Cargando...</div>
      ) : data.length === 0 ? (
        <div className="bg-white rounded-xl border p-8 text-center text-gray-500">
          No hubo ventas por categoría en este día.
        </div>
      ) : (
        <>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {data.map((c) => (
              <div key={c.category_id ?? c.category_name} className="bg-white rounded-xl border p-4">
                <div className="flex items-center justify-between">
                  <span className="font-medium text-gray-800">{c.category_name || 'Sin categoría'}</span>
                  <span className="text-xs text-gray-400">{c.percentage}%</span>
                </div>
                <p className="text-2xl font-bold text-green-600 mt-1">{formatPrice(c.total_revenue)}</p>
                <p className="text-xs text-gray-500">{c.total_sales} u. vendidas</p>
              </div>
            ))}
          </div>
          <div className="bg-primary-50 border border-primary-200 rounded-xl p-4 flex justify-between items-center">
            <span className="font-semibold text-gray-800">Total del día</span>
            <span className="text-2xl font-bold text-primary-700">{formatPrice(total)}</span>
          </div>
          <p className="text-xs text-gray-400">
            Agrupa lo vendido en el día por la categoría de cada producto/servicio. Los ítems sin
            categoría o sin producto no se incluyen.
          </p>
        </>
      )}
    </div>
  );
}
